import { useCallback, useState } from 'react'
import { useHover, useConfirmationModal } from '../../../hooks'
import { dollarTemplate, getLineItemThumbnailUrl, getLineItemPhotoLabel, getFinishTypeLabel, getLineItemMatDetails } from '../../../lib/utils'
import {Link} from 'react-router-dom'
import { ReactComponent as DeleteIcon } from '../../../images/icons/delete.svg'
import { ReactComponent as EditIcon } from '../../../images/icons/edit.svg'
import placeholderImage from '../../../images/default-placeholder.jpg'
import { MultiOpeningMatSummaryThumbnail, MULTI_OPENING_THUMB_WIDTH_SMALL, MULTI_OPENING_THUMB_HEIGHT_SMALL } from '../../LabOrderDetails/LabOrderDetailsInformation/OrderSummary/MultiOpeningLineItemSummary'
import { LineItemPhotoModal } from '../../ProductSelection/common'
import { MultiOpeningPhotoModal } from '../../ProductSelection/MultiOpening'
import styles from './Item.module.css'

const attachmentIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 256 256">
    <rect width="256" height="256" fill="none" />
    <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
  </svg>
)

const Item = ({ lineItem, position, onUpdateQty, onUpdateMultiOpeningQty, onDelete, onDeleteMultiOpening }) => {
  const [hoverRef, isHovered] = useHover()
  const { Modal, setIsOpen } = useConfirmationModal()
  const [photoModalOpen, setPhotoModalOpen] = useState(false)
  const editingSoftwareName =
    lineItem?.editingSoftware?.attributes?.name ||
    lineItem?.editingSoftware?.name ||
    lineItem?.editingSoftwareOption?.attributes?.name ||
    lineItem?.editingSoftwareOption?.name ||
    lineItem?.editingSoftwareName ||
    (typeof lineItem?.editingSoftware === 'string' ? lineItem.editingSoftware : '')
  const openModal = useCallback(
    (e) => {
      e.preventDefault()
      setIsOpen(true)
    },
    [setIsOpen],
  )

  return (
    <>
      <div
        id="w-node-c769d59e-763a-a11d-1b07-716415342c16-69e80a54"
        data-w-id="c769d59e-763a-a11d-1b07-716415342c16"
        className="w-layout-grid grid-element-order-summary smaller number"
        style={{
          gridTemplateColumns: '33px 65px 140px 110px 140px 140px 55px 60px',
        }}
        ref={hoverRef}
      >
        <div className="content center">
          <div className="div-block-266">
            <div>{Number(position + 1)}</div>
          </div>
        </div>
        <div id="w-node-c769d59e-763a-a11d-1b07-716415342c17-69e80a54" className="content">
          <div className="img-order-summary-container" style={{ width: '100%' }}>
            {lineItem?.isMultiOpening ? (
              <div
                className="w-inline-block w-lightbox"
                style={{ display: 'block', width: '100%', cursor: 'pointer' }}
                onClick={() => setPhotoModalOpen(true)}
              >
                <MultiOpeningMatSummaryThumbnail
                  lineItem={lineItem}
                  className="img-order-summary smaller"
                  maxWidth={MULTI_OPENING_THUMB_WIDTH_SMALL}
                  maxHeight={MULTI_OPENING_THUMB_HEIGHT_SMALL}
                />
              </div>
            ) : (
              <div
                className="w-inline-block w-lightbox"
                style={{ display: 'block', width: '100%', cursor: 'pointer' }}
                onClick={() => setPhotoModalOpen(true)}
              >
                <img
                  src={getLineItemThumbnailUrl(lineItem) ?? placeholderImage}
                  alt="Line item"
                  className={`img-order-summary smaller ${styles.thumbnail}`}
                />
              </div>
            )}
          </div>
        </div>
        <div className="content print-details">
          <div className="text-table-container">
            <div className="text-table smaller">
              {getFinishTypeLabel(lineItem) === 'TEST PRINTS'
                ? 'TEST PRINTS'
                : `${lineItem.printSizeAttributes.paper} ${lineItem.printSizeAttributes.printSize}`}
            </div>
            <div className="w-layout-grid grid-23 main">
              <div className="icon smaller w-embed">{attachmentIcon}</div>
              <div>{getLineItemPhotoLabel(lineItem)}</div>
            </div>
            {/* path="/product-selection/:id/edit/line-item/line_item_id" */}
            <Link to={`/product-selection/${lineItem?.labOrderGuid}/edit/line-item/${lineItem?.guid}`} lineItem = {lineItem} className="edit-mini-button link-text">
              <div className="icon smaller right-margin w-embed">
                <EditIcon />
              </div>
              Edit
            </Link>
          </div>
        </div>
        <div className="content center" style={{ textAlign: 'center' }}>
          <div className="text-table smaller">{getFinishTypeLabel(lineItem)}</div>
        </div>
        <div className="content center" style={{ textAlign: 'center' }}>
          <div className="text-table-container" style={{ justifyItems: 'center' }}>
            {!editingSoftwareName && (
              <>
                <div className="text-table smaller">
                  {lineItem?.finishingService?.formattedDetailOne}
                </div>
                <div className="text-table smaller">
                  {lineItem?.finishingService?.formattedDetailTwo}
                </div>
                <div className="text-table smaller">
                  {lineItem?.finishingService?.formattedDetailThree}
                </div>
                {getLineItemMatDetails(lineItem).map((detail) => (
                  <div key={detail} className="text-table smaller">{detail}</div>
                ))}
              </>
            )}
            {editingSoftwareName && (
              <div className="text-table smaller">{editingSoftwareName}</div>
            )}
          </div>
        </div>
        <div className="content center" style={{ textAlign: 'center' }}>
          <div>
            <div className="text-table red smaller">{lineItem?.notes}</div>
          </div>
        </div>

        <div className="content center">
          <div className="form-qty-mini w-form">
            <form id="email-form-3" name="email-form-3" data-name="Email Form 3">
              <input
                type="number"
                className="qty-input-mini w-input"
                maxLength="256"
                name="email"
                data-name="Email"
                placeholder="12"
                id="email"
                required=""
                onChange={(e) =>
                  lineItem?.isMultiOpening
                    ? onUpdateMultiOpeningQty(lineItem?.guid, e.target.value)
                    : onUpdateQty(lineItem?.guid, e.target.value)
                }
                defaultValue={lineItem?.quantity}
              />
            </form>
          </div>
        </div>

        <div id="w-node-c769d59e-763a-a11d-1b07-716415342c48-69e80a54" className="content center">
          <div className="text-table price smaller">{dollarTemplate(lineItem?.itemTotal)}</div>
        </div>
        <div
          role="button"
          style={{ opacity: isHovered ? 1 : 0 }}
          className="mini-button-delete"
          onClick={openModal}
        >
          <div className="icon smaller w-embed">
            <DeleteIcon />
          </div>
        </div>
      </div>

      <Modal
        onContinue={() => {
          setIsOpen(false)
          lineItem?.isMultiOpening ? onDeleteMultiOpening(lineItem?.guid) : onDelete(lineItem?.guid)
        }}
      />

      {lineItem?.isMultiOpening ? (
        <MultiOpeningPhotoModal
          isOpen={photoModalOpen}
          onClose={() => setPhotoModalOpen(false)}
          lineItem={lineItem}
        />
      ) : (
        <LineItemPhotoModal
          isOpen={photoModalOpen}
          onClose={() => setPhotoModalOpen(false)}
          lineItem={lineItem}
        />
      )}
    </>
  )
}

export default Item
